import { useMutation } from '@tanstack/react-query';

export function useCreateTrainingMatrixFileGenerationProcessMutation() {
  return useMutation({
    mutationFn: async ({ generationProcessParams }) => {
      const response = await axios.post(
        '/training_matrix/file_generation_processes',
        {
          file_generation_process: { filter: generationProcessParams },
        },
      );
      return response.data;
    },
  });
}
